export default {
  explore: {
    filters: 'Фільтри',
    resetFilters: 'Скинути фільтри',
    addKeyword: 'Додати ключове слово',
  },
  recipe: {
    contributedBy: 'Автор',
    ingredients: 'Інгредієнти',
    directions: 'Способи приготування',
    fullRecipe: 'Подивитися повний рецепт на',
    similarDrinks: 'Подібні напої',
  },
  featuredRecipes: {
    loadMore: 'Завантажити більше',
  },
  recipeFind: {
    filterBy: 'Фільтрувати за',
    name: 'Назва',
    ingredients: 'Інгредієнти',
    keywords: 'Ключові слова',
    searchForIngredients: 'Ви можете шукати кілька інгредієнтів, розділяючи їх пробілом',
    searchForKeywords: 'Ви можете шукати кілька ключових слів, розділяючи їх пробілом',
  },
  recipeList: {
    viewRecipe: 'Переглянути рецепт',
  },
  recipeToolbar: {
    print: 'Роздрукувати',
    share: 'Поділитися',
    shareOnFacebook: 'Поділитися через Facebook',
    shareOnTwitter: 'Поділитися через Twitter',
    copyURL: 'скопіювати URL',
    hideImage: 'Приховати зображення',
  },
  favorites: {
    removeAllFavorites: 'Видалити всі вибране',
    noFavoriteDrinks: 'У вас немає улюблених напоїв',
    removeFavoritesPrompt: 'Ви впевнені, що хочете видалити всі вибрані',
    delete: 'Видалити',
    cancel: 'Скасувати',
  },
  keywordList: {
    enterYourKeyword: 'Введіть ключове слово',
  },
  search: {
    findYourDrink: 'Знайдіть свій напій',
  },
  pageNotFound: {
    pageNotFound: 'Сторінку, яку ви шукаєте, не знайдено',
    backToHome: 'Повернутися додому',
  },
};
